import { Store } from '@medlinker/fundamental';
import qs from 'qs';

export interface AppState {
  appInitParmas: Record<string, string>;
}

const model = {
  name: 'medgptWlys',
  state: { appInitParmas: {} } as AppState,
  persist: true,
  reducers: {
    setAppInitParmas(state: AppState, payload: AppState['appInitParmas']) {
      state.appInitParmas = payload;
    },
  },
  effects: {
    async init(payload: {}, store: Store) {
      const query = qs.parse(location.search);

      if (
        query.__medgpt_wlys_init_params &&
        typeof query.__medgpt_wlys_init_params === 'string'
      ) {
        try {
          const params = JSON.parse(
            decodeURIComponent(query.__medgpt_wlys_init_params) as string
          );

          store.dispatch.medgptWlys.setAppInitParmas(params);
        } catch (error) {
          console.error('Failed to parse init params:', error);
        }
      }
    },
  },
};

export default model;
